import { computed, reactive } from '@vue/composition-api';

type FileData = { file: File };

export const useInputFile = () => {
  const state = reactive<{ files: FileData[] }>({
    files: [],
  });

  const handleChangeFile = (fileData: FileData[]) => {
    state.files = fileData;
  };

  return { files: computed(() => state.files), handleChangeFile };
};
